import { PrescriptionAssistantModal } from '@/shared-ui/PrescriptionAssistantModal/PrescriptionAssistantModal';

interface NoShowConfirmationModalProps {
  open: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const NoShowConfirmationModal = ({ open, onConfirm, onClose }: NoShowConfirmationModalProps) => (
  <PrescriptionAssistantModal
    open={open}
    title="Confirm No Show"
    severity="warning"
    body="Are you sure to set this consultation as No Show?"
    confirmLabel="Yes, Confirm No Show"
    closeLabel="Cancel"
    onConfirm={onConfirm}
    onClose={onClose}
  />
);
